export const IMPUTATION_IMPORT_HEADER_ROW = [
  "category",
  "subcategory",
  "departments",
  "gl_natural",
  "gl_office",
  "cost_type",
  "tax_code",
  "approver_1_first_name",
  "approver_1_last_name",
  "approver_2_first_name",
  "approver_2_last_name",
].join(",");

export function downloadImputationImportTemplateCsv() {
  const blob = new Blob([`${IMPUTATION_IMPORT_HEADER_ROW}\n`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "imputations-import-template.csv";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
